export const getFileType = (mimeType: string): 'image' | 'video' | undefined => {
  if (mimeType.includes('image')) return 'image'
  if (mimeType.includes('video')) return 'video'
  return undefined
}

export const downloadFromUrl = (url: string, fileName?: string): void => {
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName || '')
  document.body.appendChild(link)
  link.click()
}
